import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import _map from "lodash/map"
import _size from "lodash/size"

import TextInformartionBand from "components/TextInformationBand"

import { formatInfo } from "../../utils/formatInfo"

import styles from "./styles.css"
import ImageOk from "assets/svg/icon-ok.svg"
import EmptyState from "shared/components/EmptyState"

const DetailList = ({ trafficDataDetailsList, t, ...props }) => {
  const containerClasses = classnames(styles.marginSection, styles.container)

  if (!_size(trafficDataDetailsList)) {
    return (
      <EmptyState
        icon={ImageOk}
        title="Desculpe!"
        description={t("NO_REGISTER")}
        isContainer={false}
        classNames={styles.emptyState}
      />
    )
  }
  return (
    <section className={containerClasses}>
      {_map(trafficDataDetailsList, (item, index) => {
        const infos = formatInfo(item)
        const classNames = index !== 0 ? styles.textInformationMargin : ""

        return <TextInformartionBand infos={infos} classNames={classNames} />
      })}
    </section>
  )
}

DetailList.propTypes = {
  trafficDataDetailsList: PropTypes.array,
  t: PropTypes.func
}

export default DetailList



// WEBPACK FOOTER //
// ./src/scenes/DataTraffic/components/DetailsList/index.js